/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowMatch = {
    properties: {
        match: {
            type: 'MatchSmall',
            isRequired: true,
        },
        notification: {
            type: 'boolean',
            isRequired: true,
        },
        liveActivity: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
